import React from "react";
import styled from "styled-components";
import theme from "../../../theme";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const { colors, fonts } = theme;

export const ParagraphContainer = styled.div`
  color: ${colors.secondary};
  font-family: ${fonts.heading};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;

  /* Style only the content processed by ReactMarkdown */
  .markdown-content {
    p {
      margin: 0 0 8px 0;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
ParagraphContainer.displayName = "Paragraph";

const formatMarkdownText = (text) => {
  return (
    text
      // remove unwanted span wrappers with white-space: pre-wrap
      .replace(/<span style="white-space: pre-wrap;">(.*?)<\/span>/g, "$1")
      // add new lines before headings
      .replace(/(\s#)/g, "\n$1")
      // replace <br> with new line
      .replace(/<br>/g, "\n")
      // add new lines before list items
      .replace(/\s-/g, "\n-")
  );
};

const Paragraph = ({ children }) => (
  <ParagraphContainer>
    {typeof children === "string" ? (
      <ReactMarkdown
        className="markdown-content"
        rehypePlugins={[rehypeRaw]}
        remarkPlugins={[remarkGfm]}
        children={formatMarkdownText(children)}
      />
    ) : (
      children
    )}
  </ParagraphContainer>
);

export default Paragraph;
